module.exports = __webpack_public_path__ + "static/img/activity-20210915.1dbadca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20210915.png
// module id = v6fV
// module chunks = 0